// extracted by mini-css-extract-plugin
export default {"tooltip":"FQ-z","arrow":"GQ-z"};